<template>
  <modal v-show="visible" :title="title" :progress="isLoading" @close="close">
    <template v-slot:body>
      <span v-if="!isLoading" class="message">
        {{ message }}
      </span>
      <template v-else>
        <circle-2
          class="centered loading-spinner"
          color="transparent"
          :background="spinnerColor"
        />
        <span class="loading-text">Loading...</span>
      </template>
    </template>

    <template v-slot:footer>
      <div v-if="!isLoading">
        <el-button
          type="danger"
          size="small"
          title="Delete"
          class="delConversionButton"
          @click="startDelete"
        >
          Delete
        </el-button>
        <el-button
          type="primary"
          size="small"
          title="Cancel"
          class="delConversionButton"
          @click="close"
        >
          Cancel
        </el-button>
      </div>
      <div v-else />
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/dialog/Modal.vue";
import { Circle2 } from "vue-loading-spinner";

// @group Dialog
// Remove confirmation modal
export default {
  name: "RemoveConfirmation",
  components: {
    Modal,
    Circle2
  },
  props: {
    /** Is modal visible */
    visible: {
      type: Boolean,
      default: false
    },
    /** Confirmation message */
    message: {
      type: String,
      default: "Are you sure?"
    },
    /** Modal title */
    title: {
      type: String,
      default: "Remove Confirmation"
    }
  },
  data() {
    return {
      /** is remove in process */
      isLoading: false,
      /** loading spinner color */
      spinnerColor: "var(--grey)"
    };
  },
  methods: {
    // @vuese
    // Close modal
    close() {
      this.$emit("close");
    },
    // @vuese
    // Start remove process
    startDelete() {
      this.isLoading = true;
      this.$emit("delete", {
        done: this.finishDelete,
        cancel: () => {
          this.isLoading = false;
        }
      });
    },
    // @vuese
    // Finish remove process
    finishDelete() {
      this.isLoading = false;
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.centered {
  margin-left: auto;
  margin-right: auto;
}
.loading-spinner {
  margin-bottom: 10px;
}
.loading-text {
  color: var(--grey);
}
</style>
